<template>
  <v-dialog v-model="$root.confirmAddFile.isVisible" persistent>
    <v-card>
      <v-toolbar class="trHeader" style="height: 40px;">
        <v-toolbar-title class="white--text" style="text-align:center;">{{title}}</v-toolbar-title>
      </v-toolbar>
      <v-flex>
        <v-card-text>
          <span class="custom-dropdown custom-dropdown--white" style="width: 200px;">
            <select v-model="addType" class="custom-dropdown__select custom-dropdown__select--white">
              <option value="File">הוסף מסמך חדש</option>
              <option value="Folder">הוסף תיקייה חדשה</option>
            </select>
          </span>
        </v-card-text>
      </v-flex>
      <v-flex v-if="addType=='File'">
        <v-layout row wrap style="padding: 20px 10px 10px 10px;">
          <v-flex xs4 right>
            שם קובץ
          </v-flex>
          <v-flex xs8>
            <input type="text" v-model="fileName" />
          </v-flex>
        </v-layout>
        <v-layout row wrap style="padding: 20px 10px 10px 10px;">
          <v-flex xs5 right>
            <label class="file-select">
              בחר קובץ
              <v-icon right class="btnIcon mr-2">attachment</v-icon>
              <input type="file" @change="upload" />
            </label>
          </v-flex>
          <v-flex xs7 right>
            <span v-if="showProgress">מעלה קובץ...</span>
            <span v-if="showReady">{{readyFileName}}<v-icon>check</v-icon></span>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex v-if="addType=='Folder'">
        <v-layout row wrap style="padding: 20px 10px 10px 10px;">
          <v-flex xs4 right>
            שם תיקייה
          </v-flex>
          <v-flex xs8>
            <input type="text" v-model="folderName" />
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex actions>
        <v-btn outline small class="green green--text ml-3" @click.native="save">
          שמירה
          <v-icon left>check</v-icon>
        </v-btn>
        <v-btn outline small class="red red--text ml-2" @click.native="cancel">
          ביטול
          <v-icon left>block</v-icon>
        </v-btn>
      </v-flex>
    </v-card>
  </v-dialog>
</template>
<script>

  import { db, storage } from '../firebase';

  export default {
    name: 'PopupAddFile',
    props: ['isVisible'],
    data() {
      return {
        title: 'הוספת מסמך חדש',
        addType: 'File',
        folderName: '',
        fileName: '',
        showFile: false,
        showProgress: false,
        showReady: false,
        fileUrl: '',
        readyFileName: '',
      }
    },
    created() {
      this.$Log("Vue [PopupAddFile] is created ...");
    },
    ready() {
      this.$Log("Vue [PopupAddFile] is ready ...");
    },
    mounted() {
      this.$Log("Vue [PopupAddFile] is mounted ...");
    },
    updated() {
      this.$Log("Vue [PopupAddFile] is updated ...");
    },
    watch: {
      addType(val) {
        switch (val) {
          case 'File': this.title = 'הוספת מסמך חדש'; break;
          case 'Folder': this.title = 'הוספת תיקייה חדשה'; break;
        }
      }
    },
    methods: {
      confirmed(val) {
        this.$root.confirm = {
          isVisible: false,
          title: '',
          question: '',
          caller: this.$root.confirm.caller,
          isConfirmed: val
        };
      },
      upload(e) {
        var vm = this;
        vm.readyFileName = '';
        var files = e.target.files || e.dataTransfer.files;
        if (!files.length) return;

        var file = files[0];
        var image = new Image();
        var reader = new FileReader();

        reader.onload = (ev) => {
          vm.logoUrl = ev.target.result;
        };
        reader.readAsDataURL(file);

        vm.showFile = true;
        vm.showProgress = true;

        var planKey = vm.$route.params.planKey;

        if (planKey) {
          var storageRef = storage.ref('planes/' + planKey + '/' + file.name);
          var task = storageRef.put(file);

          task.on('state_changed',
            function progress(snap) {
              //vm.percent = (snap.bytesTransferred / snap.totalBytes) * 100;
            },
            function error(err) {
              vm.showFile = false;
              vm.showProgress = false;
            },
            function complete() {
              vm.fileUrl = task.snapshot.downloadURL;
              vm.showFile = false;
              vm.showProgress = false;
              vm.showReady = true;
              vm.readyFileName = file.name;
            }
          );
        }
        else {
          vm.$root.alert.message = 'העלאת קובץ נכשלה!!';
          vm.$root.alert.isShow = true;
        }

      },
      save() {
        if (this.addType == "File") {
          if (this.showReady) {
            this.insertFile();
          }
          else {
            alert("העלאת קובץ לא הסתיימה!");
          }
        }
        if (this.addType == "Folder") {
          this.insertFolder();
        }
      },
      insertFile() {
        var vm = this;
        var file = {
          Title: vm.fileName,
          Url: vm.fileUrl
        }
        var path = this.$root.confirmAddFile.path + "/Files";
        var planeFilesRef = db.ref(path).push(file);
        vm.$root.isUpdatedPlan = true;
        vm.reset();
      },
      updateFile() {

      },
      insertFolder() {
        var vm = this;
        var folder = {
          Title: vm.folderName
        }
        var path = this.$root.confirmAddFile.path + "/SubFolders";
        var planeSubFoldersRef = db.ref(path).push(folder);
        vm.$root.isUpdatedPlan = true;
        vm.reset();
      },
      updateFolder() {

      },
      cancel() {
        this.reset();
      },
      reset() {
        this.addType = 'File';
        this.folderName = '';
        this.fileName = '';
        this.showFile = false;
        this.showProgress = false;
        this.showReady = false;
        this.fileUrl = '';
        this.readyFileName = '';
        this.$root.confirmAddFile.path = '';
        this.$root.confirmAddFile.isVisible = false;
      }
    }
  }

</script>
<style></style>



// WEBPACK FOOTER //
// PopupAddFile.vue?e2057e96